import {Typography} from '@viptech/react-components'
import {useEffect, useState} from 'react'

type CountdownButtonProps = {
  onClick: () => void
  seconds: number
  disabled?: boolean
}

export default function EmailCountdownButton({onClick, disabled = false, seconds}: CountdownButtonProps) {
  const [countdown, setCountdown] = useState(seconds)
  const [isCounting, setIsCounting] = useState(true)

  useEffect(() => {
    if (isCounting) {
      const interval = setInterval(() => {
        setCountdown((prev) => prev - 1)
      }, 1000)
      return () => clearInterval(interval)
    }
  }, [isCounting])

  useEffect(() => {
    if (countdown === 0) {
      setIsCounting(false)
    }
  }, [countdown])

  useEffect(() => {
    if (disabled) {
      setCountdown(seconds)
      setIsCounting(false)
    }
  }, [disabled])

  const formatSeconds = (seconds: number) => {
    const minutes = Math.floor(seconds / 60)
    const remainingSeconds = seconds % 60
    return `${String(minutes).padStart(2, '0')}:${String(remainingSeconds).padStart(2, '0')}`
  }

  if (isCounting)
    return (
      <Typography variant='label' size='14px' weight={400} family='Inter' color='#667085'>
        Reenviar e-mail: {formatSeconds(countdown)}
      </Typography>
    )

  return (
    <Typography
      variant='label'
      size='14px'
      weight={400}
      family='Inter'
      color='#009EFF'
      cursor='pointer'
      onClick={() => {
        onClick()
        setCountdown(seconds)
        setIsCounting(true)
      }}>
      Reenviar e-mail
    </Typography>
  )
}
